var map = {
	"./About-us-hero.svg": 3408,
	"./Esfahan-Datacenter.png": 9812,
	"./Hero-bg.png": 585,
	"./avatar/avatar-1.jpeg": 6166,
	"./avatar/avatar.png": 8098,
	"./blog/Rectangle-43.png": 9520,
	"./blog/icon-play.png": 9947,
	"./blog/image-left-sidebar.png": 9769,
	"./blog/image-show-articles.png": 8106,
	"./blog/show-1.png": 9665,
	"./blog/show-2.png": 5998,
	"./blog/show-3.png": 3629,
	"./blog/show-4.png": 4136,
	"./blog/video-header.png": 6222,
	"./comment-home/image1.png": 5819,
	"./comment-home/image2.png": 2466,
	"./comment-home/image3.png": 4052,
	"./comment-home/image4.png": 9972,
	"./comment-home/undraw_comment.svg": 25,
	"./dashboard/bg-wave-1.svg": 8434,
	"./dashboard/bg-wave-2.svg": 5776,
	"./error-illustration.svg": 3801,
	"./flags/iran.svg": 7034,
	"./flags/us.svg": 4679,
	"./homepage-hero.png": 222,
	"./logo/Licenses.png": 2913,
	"./logo/Makhhash.png": 4458,
	"./logo/Pezhvak-logo.png": 8386,
	"./logo/tapco-logo.png": 6915,
	"./mask-group.svg": 4296,
	"./mining-image.jpeg": 1078,
	"./moon.svg": 2784,
	"./pages/home-hero-bg.jpg": 9073,
	"./pages/makhhash-feature-1.png": 736,
	"./pages/makhhash-feature-2.png": 1283,
	"./pages/makhhash-feature-3.png": 6599,
	"./pages/mining/cloud-mining-hero-bg.jpg": 5300,
	"./pages/mining/what-is-mining.jpg": 1835,
	"./pages/mining/where-to-start.jpg": 7607,
	"./pages/mining/why-makhmining.jpg": 846,
	"./pages/support-hero-bg.jpg": 5848,
	"./qazaqstan-datacenter.jpg": 2224,
	"./sun.svg": 5056,
	"./undraw_comment.svg": 5297
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;